<template lang="pug">
section.i_ptb_10
  .container
    h2.i_h2_title.text-center.text-md-left {{ homeData.area02_Title }}
    p.i_body_l.i_mt_6.i_mt_md_4.i_mt_sm_6 {{ homeData.area02_SubTitle }}
    .slider_solutions.i_mt_6
      swiper.swiper-container(:options="swiperOption", ref="mySwiper")
        swiper-slide.swiper-slide(
          v-for="(sliderContent, index) in homeData.area02_PackageList",
          :key="index"
        )
          .solution
            .img.d-none.d-md-block(
              v-if="sliderContent",
              :style="{ backgroundImage: 'url(' + sliderContent.area02_PackageList_Image + ')' }"
            )
            .solution_content.i_ptb_3.i_plr_8.i_p_md_4.i_plr_sm_12.i_ptb_sm_6
              .head_wrapper.d-flex.justify-content-between.align-items-center
                h5.i_pr_4 {{ sliderContent.area02_PackageList_Title }}
                .img.d-md-none(
                  v-if="sliderContent",
                  :style="{ backgroundImage: 'url(' + sliderContent.area02_PackageList_Image + ')' }"
                )
              p.i_body_l.i_mt_sm_4 {{ sliderContent.area02_PackageList_SubTitle }}
              .see_more_btn.sm.btn_blue_ci(
                v-if="sliderContent.area02_PackageList_ID && sliderContent.area02_PackageList_ID != ''",
                @click="toCombination(sliderContent.area02_PackageList_ID)"
              ) 看更多
      svg-icon.swiper-prev.d-none.d-md-block(
        v-if="homeData.area02_PackageList && homeData.area02_PackageList.length > 3",
        iconClass="arrow_left_large",
        className="icon",
        @click="prevClick"
      )
      svg-icon.swiper-prev.d-md-none(
        iconClass="arrow_left_mobile",
        className="icon",
        @click="prevClick"
      )

      svg-icon.swiper-next.d-none.d-md-block(
        v-if="homeData.area02_PackageList && homeData.area02_PackageList.length > 3",
        iconClass="arrow_right_large",
        className="icon",
        @click="nextClick"
      )
      svg-icon.swiper-next.d-md-none(
        iconClass="arrow_right_mobile",
        className="icon",
        @click="nextClick"
      )
</template>

<script>
export default {
  name: "Solutions",
  props: {
    homeData: Object,
  },
  data() {
    var self = this;

    //初始slider可見個數
    let views;
    if (document.body.clientWidth <= 767) {
      views = 1;
    } else {
      views = 3;
    }

    return {
      swiperOption: {
        notNextTick: true,
        initialSlide: 0,
        spaceBetween: 0,
        slidesPerView: views,
        loop: false,
        direction: "horizontal",
        grabCursor: false,
        setWrapperSize: true,
        autoHeight: false,
        mousewheelControl: true,
        observeParents: true,
        debugger: true,
        paginationClickable: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        on: {
          resize: function () {
            self.updateSliders();
            this.update();
          },
        },
      },
    };
  },
  computed: {
    sliderSolutionSwiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  methods: {
    prevClick() {
      this.sliderSolutionSwiper.slidePrev();
    },
    nextClick() {
      this.sliderSolutionSwiper.slideNext();
    },
    updateSliders() {
      if (document.body.clientWidth <= 767) {
        this.sliderSolutionSwiper.params.slidesPerView = 1;
      } else {
        this.sliderSolutionSwiper.params.slidesPerView = 3;
      }
    },
    itemClick(url) {
      window.open(url);
    },
    toCombination(ID) {
      this.$router.push({
        name: "ProductCombo",
        params: {
          id: ID,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/home/slider_solutions";
</style>
